import script from "./applicant-details.vue?vue&type=script&setup=true&lang=js"
export * from "./applicant-details.vue?vue&type=script&setup=true&lang=js"

import "./applicant-details.vue?vue&type=style&index=0&id=ba966a7e&lang=css"

const __exports__ = script;

export default __exports__